import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, ArrowUpRight } from 'lucide-react';
import { posterFor, disclosureFor, filmDate } from '@/data/tlb/catalogue';

export const FilmCard = ({ film, featured = false, prefix = 'catalogue' }) => {
  const internal = film.destination.startsWith('/');
  const Component = internal ? Link : 'a';
  return <article className={`tlb-film-card ${featured ? 'tlb-featured-film' : ''}`} data-testid={`${prefix}-record-${film.youtube_id}`}>
    <Component {...(internal ? { to: film.destination } : { href: film.watch_url, target: '_blank', rel: 'noopener' })} data-testid={`${prefix}-film-${film.youtube_id}`} aria-label={`${film.canonical_public_title}. ${film.destination_label}`}>
      <figure className="tlb-film-image">
        <img src={posterFor(film)} alt={`${film.display_title}, ${disclosureFor(film) || 'published film thumbnail'}`} width="1200" height="675" loading="lazy" />
        {disclosureFor(film) && <figcaption className="tlb-disclosure" data-testid={`${prefix}-disclosure-${film.youtube_id}`}>{disclosureFor(film)}</figcaption>}
      </figure>
      <div className="tlb-film-copy">
        <p className="tlb-eyebrow">{featured ? 'Featured film · ' : ''}{film.editorial_thread}</p>
        <h3 data-testid={`${prefix}-title-${film.youtube_id}`}>{film.display_title}</h3>
        <p>{film.editorial_dek_proposed}</p>
        <p className="tlb-mono tlb-film-meta" data-testid={`${prefix}-metadata-${film.youtube_id}`}><span>{film.duration_label} · {film.language_format}</span><time dateTime={film.published_date}>{filmDate(film)}</time></p>
        <span className="tlb-card-action">{film.destination_label}{internal ? <ArrowRight aria-hidden="true" /> : <ArrowUpRight aria-hidden="true" />}</span>
      </div>
    </Component>
  </article>;
};